import type { IMenuItemEntry } from '@move-frontend/contentful';
import type React from 'react';
import { MenuItem } from '../../../../../../ui/new-components/MenuItem';
import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';
import { useTranslation } from '../../../../i18n/translate/useTranslation';
import { StyledMainNavListItemWrapper } from '../StyledNavigationItems';

export const SectionWithoutSubmenuNavItem = ({
	id,
	item,
}: {
	id: string;
	item: IMenuItemEntry;
}) => {
	const { t } = useTranslation();
	const { title } = item.fields;
	const href = useUrlForPageId(item?.fields?.page?.fields.id || '');

	return (
		<StyledMainNavListItemWrapper id={id} role="none">
			<MenuItem
				title={title}
				href={href}
				aria-label={t('nav_item_link_to_page_label', { title })}
				role="menuitem"
			/>
		</StyledMainNavListItemWrapper>
	);
};
